import React from 'react';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import { employmentStatusChoices } from '../../../../constants/employmentStatuses';
import conflictFields from '../../../../constants/conflictFields';
import { EmploymentStatusParameters } from '../../questionParameters';
import applyChoices from '../../applyChoices';

const CONTENT = {
  [languages.SV]: 'Anställning',
  [languages.EN]: 'Employment',
  [languages.DE]: 'Beschäftigung',
};

const ValueField = ({
  extraParameters,
  language,
}: {
  extraParameters?: EmploymentStatusParameters;
  language?: Languages;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;
  const choices = applyChoices(
    employmentStatusChoices(language),
    extraParameters?.options,
    extraParameters?.choiceLabels,
  );

  return <SelectField choices={choices} record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const EmploymentStatus = (
  {
    extraParameters,
  }: {
    extraParameters?: EmploymentStatusParameters;
  },
) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="employmentStatus"
      datapoint={conflictFields.EMPLOYMENT_STATUS}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

EmploymentStatus.ValueField = ValueField;

export default EmploymentStatus;
